module.exports = __webpack_public_path__ + "static/media/17.86719447.jpg";